module.exports = ".logo {\n  height: 60px;\n  text-align: center;\n  padding-top: 5vh;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box; }\n  .logo img {\n    height: 100%;\n    width: auto; }\n  .logo:hover {\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/common-components/logo-2/logo-2.component.scss
// module id = ./src/app/home/common-components/logo-2/logo-2.component.scss
// module chunks = main